import { render } from "./user.vue?vue&type=template&id=db97e302"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
script.render = render

export default script